'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _information = require('./information.service');

var _information2 = _interopRequireDefault(_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var informationModule = _angular2.default.module('information.service', []).service('Information', _information2.default).name;

exports.default = informationModule;


// WEBPACK FOOTER //
// ./client/app/services/informationService/information.js